import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import "./App.css";
import FooterComponent from "./components/footer-component";
import HeaderComponent from "./components/header-components";
import PageMainContent from "./components/page-main-content";
import ThankYou from "./components/thankyou";
import ThankYouEng from "./components/thankyou_eng";
import ThankYouTwo from "./components/thankYouTwo";
import ThankYouThree from "./components/thankyouThree"

function App() {
  
  return (
    <>
      {/* update basename while pushing to UAT/LIVE {UAT: /v2/46725/lp/cc/platinumCreditCard/cardOnCard/, live:window.location.pathname }  */}
      <Router basename={window.location.pathname}>
        <div>
          <HeaderComponent></HeaderComponent>
          <Routes>
            <Route path="/" element={<PageMainContent />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/thank-you-eng" element={<ThankYouEng />} />
             <Route path="/thankYouTwo" element={<ThankYouTwo />} />
               <Route path="/thankYouThree" element={<ThankYouThree />} />
          </Routes>
          <FooterComponent></FooterComponent>
        </div>
      </Router>
    </>
  );
}

export default App;
